import { render, staticRenderFns } from "./ChopList.vue?vue&type=template&id=dcf55222&"
import script from "./ChopList.vue?vue&type=script&lang=js&"
export * from "./ChopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports